export default __webpack_public_path__ + "static/media/open_frame.bf663cc9.jpg";